import { Injectable } from '@angular/core';
import {Headers, Http} from "@angular/http";
import {AuthService} from "../../auth/auth.service";
import {environment} from "../../../environments/environment";
import {TemplateFolderShare} from "./template-folder-share";

@Injectable()
export class TemplateFolderShareService {

  private endpoint = environment.apiBaseUrl + '/api/v1.0/';
  private headers = new Headers({ 'Content-Type': 'application/json' });

  constructor(private http: Http, private authService: AuthService) { }

  delete(folder): Promise<TemplateFolderShare> {

    const url = this.endpoint + 'user/' + this.authService.getCurrentUser().id + '/storyboard_template_folder/' + folder.id + '/share/' + folder.share.id;

    return this.http
      .delete(url, {headers: this.headers})
      .toPromise()
      .then(() => {
        folder.share_url = null;
        folder.is_shared = false;
      })
      .catch(this.handleError);
  }

  create(folder): Promise<TemplateFolderShare> {

    const url = this.endpoint + 'user/' + this.authService.getCurrentUser().id + '/storyboard_template_folder/' + folder.id + '/share';

    return this.http
      .post(url, {}, {headers: this.headers})
      .toPromise()
      .then(response => {
        let share = TemplateFolderShare.fromJson(response.json());
        folder.share_url = share.share_url;
        folder.share = share;
        folder.is_shared = true;
        return share;
      })
      .catch(this.handleError);
  }

  private handleError(error: any): Promise<any> {
    console.error('An error occurred', error);
    return Promise.reject(error.message || error);
  }

}



// WEBPACK FOOTER //
// ./src/app/template/shared/template-folder-share.service.ts